import type { SVGAttributes } from "react";

export const FooterSocialItems = {
	instagram: {
		name: "Instagram",
		baseURL: "https://www.instagram.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
				<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
				<line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
			</svg>
		),
	},
	facebook: {
		name: "Facebook",
		baseURL: "https://www.facebook.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
			</svg>
		),
	},
	x: {
		name: "X (formerly Twitter)",
		baseURL: "https://www.x.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => {
			return (
				<svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" stroke="currentColor">
					<path d="M178.6 127.2 290.3 0h-26.5l-97 110.4L89.3 0H0l117.1 167L0 300.2h26.5l102.4-116.6 81.8 116.6H300M36 19.4h40.7l187 262.2h-40.6" />
				</svg>
			);
		},
	},
	youtube: {
		name: "YouTube",
		baseURL: "https://www.youtube.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" />
				<polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02" />
			</svg>
		),
	},
	linkedin: {
		name: "LinkedIn",
		baseURL: "https://www.linkedin.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
				<rect x="2" y="9" width="4" height="12" />
				<circle cx="4" cy="4" r="2" />
			</svg>
		),
	},
	tiktok: {
		name: "TikTok",
		baseURL: "https://www.tiktok.com/",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm10-9a3 3 0 0 0-3 3v10a7 7 0 1 1-7-7V7a7 7 0 0 1 7 7h3V3z" />
			</svg>
		),
	},
	email: {
		name: "Email",
		baseURL: "mailto:",
		icon: (props: SVGAttributes<SVGSVGElement>) => (
			<svg
				{...props}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 24 24"
				fill="none"
				stroke="currentColor"
			>
				<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
				<polyline points="22,6 12,13 2,6" />
			</svg>
		),
	},
};

export type FooterSocialKey = keyof typeof FooterSocialItems;
